import { object, string } from 'yup'

export const familyContactSchema = object().shape({
  fullName: string().required('Preencha o campo').min(1),
  relationship: string().required('Preencha o campo').min(1).nullable(),
  phone: string().required('Preencha o campo').min(11, 'Telefone inválido')
})